import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { PRIVACY_POLICY_DOCUMENT } from "../content/legalDocuments";

export default function PrivacyPolicyPage() {
  return <LegalDocumentPage document={PRIVACY_POLICY_DOCUMENT} />;
}
